import { FC, memo } from 'react';
import { HeroConversation } from '@vs-online-only-app/state';
import ActiveConversationItem from './ActiveConversationItem';
import { ConversationItemsPlaceholder } from './ConversationsItemsPlaceholder';

type Props = {
  activeConversations: HeroConversation[];
};

const ActiveConversationsList: FC<Props> = ({ activeConversations }) => {
  if (!activeConversations.length) {
    return <ConversationItemsPlaceholder />;
  }

  return (
    <>
      {activeConversations.map((conversation) => (
        <ActiveConversationItem
          key={conversation.id}
          conversation={conversation}
        />
      ))}
    </>
  );
};

export default memo(ActiveConversationsList);
